import { render, staticRenderFns } from "./new.presentations.page.vue?vue&type=template&id=6863f979&"
import script from "./new.presentations.page.vue?vue&type=script&lang=js&"
export * from "./new.presentations.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports